import moment from "moment";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

import { useGetMyRequestsQuery } from "../../../slices/ClientRequestsSlice";
import { progressOf } from "../../clientRequests/clientRequests.utils";

/** Portal home: "Requests from <firm>" (hidden when there are none). */
export const PortalRequestsCard: FC<{ customerId: string }> = ({
  customerId,
}) => {
  const navigate = useNavigate();
  const { data } = useGetMyRequestsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const list = (data ?? []).filter((r) => r.customerId === customerId);
  if (!list.length) return null;
  const open = list.filter((r) => r.status === "sent");

  return (
    <section
      className={
        "flex flex-col gap-3 rounded-[14px] border border-[#E8E8EC] bg-white p-[18px] sm:p-6"
      }>
      <h2 className={"m-0 text-base font-extrabold sm:text-[17px]"}>
        Requests from {list[0].firmName}
      </h2>
      <ul className={"m-0 flex list-none flex-col gap-2 p-0"}>
        {list.map((r) => {
          const p = progressOf(r);
          const isOpen = r.status === "sent";
          return (
            <li
              key={r.id}
              className={`flex flex-wrap items-center gap-3 rounded-[12px] px-4 py-3 ${
                isOpen
                  ? "border-[1.5px] border-[#D9D1FF] bg-[#F7F5FF]"
                  : "border border-[#EDEFF3]"
              }`}>
              <div className={"flex min-w-0 flex-1 flex-col gap-1"}>
                <span className={"truncate text-sm font-extrabold"}>
                  {r.title}
                </span>
                <span
                  className={`text-[12.5px] font-semibold ${
                    isOpen ? "text-[#6B7185]" : "text-[#12805C]"
                  }`}>
                  {isOpen
                    ? `${p.label} done${
                        r.dueDate
                          ? ` · please finish by ${moment(
                              r.dueDate,
                              "YYYY-MM-DD",
                            ).format("MMM D")}`
                          : ""
                      }`
                    : "✓ Complete · thank you!"}
                </span>
                {isOpen && (
                  <div
                    className={
                      "h-1.5 w-full max-w-[260px] overflow-hidden rounded-full bg-white"
                    }>
                    <div
                      className={"h-full rounded-full bg-[#6B4EFF]"}
                      style={{ width: `${p.percent}%` }}
                    />
                  </div>
                )}
              </div>
              <button
                type={"button"}
                onClick={() => navigate(`/portal/requests/${r.id}`)}
                className={
                  isOpen
                    ? "h-10 rounded-[9px] bg-[#6B4EFF] px-4 text-[13.5px] font-extrabold text-white hover:bg-[#5B3DF5]"
                    : "h-10 rounded-[9px] border border-[#DCE2EA] bg-white px-4 text-[13.5px] font-bold text-[#3A4256] hover:bg-[#F7F8FA]"
                }>
                {isOpen ? (p.done ? "Continue" : "Start") : "View"}
              </button>
            </li>
          );
        })}
      </ul>
      {open.length === 0 && (
        <span className={"text-[12.5px] font-medium text-[#6B7185]"}>
          Nothing to do right now.
        </span>
      )}
    </section>
  );
};
